import { FC, CSSProperties, ReactNode, } from "react";
import { ProCol } from "../antd";
import { BaseSearchFormItemProps, SearchFormItemEnum } from "./interface/baseInterface";

export interface SearchFormLineProps extends BaseSearchFormItemProps {
  lineProps?: {
    className?: string;
    style?: CSSProperties;
  };
  children?: ReactNode;
};
/** 分割线 */
const SearchFormLine: FC<SearchFormLineProps> = props => {
  const {lineProps, children, style, span, offset, order, pull, push} = props;
  return (
    <ProCol
      style={{ ...style, position: 'relative' }}
      span={span}
      offset={offset}
      order={order}
      pull={pull}
      push={push}
    >
      <div className="scan-dashed-line" {...lineProps}>{children}</div>
    </ProCol>
  );
};

SearchFormLine.displayName = SearchFormItemEnum.SearchFormLine;

export default SearchFormLine
